<template>
    <div>
        <EditUser />
    </div>
</template>

<script>
import EditUser from '@/components/user/EditUser.vue';
export default {
    components: {
        EditUser
    },
    name: 'UserEdit'
}
</script>